var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-client",attrs:{"to":{ name: 'company' }}},[(!_vm.clientLogo)?_c('div',{staticClass:"logo-client__no-logo"}):_vm._e(),_vm._v(" "),(_vm.clientLogo)?_c('img',{staticClass:"logo-client__img",attrs:{"src":_vm.clientLogo}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80236b9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sc-client-logo/ScClientLogo.vue
// module id = null
// module chunks = 